// Whether this console talks to the Loremaster's Compass desktop app at all.
//
// Per DEVICE, not per profile: the Compass app and its connector run on a
// particular machine, so "I use the Compass here" is a question about this
// browser, the same reasoning that puts the theme in localStorage. A DM who
// signs into their profile on a borrowed laptop with no Compass should not drag
// a "Compass on" setting there, nor have it synced back.
//
// When off, App unmounts the two Compass lanes (CompassLive, PrefsSync); their
// effect cleanups unsubscribe from the bridge and stop every push and pull, so
// this is a real gate, not a hidden card. Default ON: an unset value means a DM
// who has never touched this, and the Compass lane is dormant anyway until the
// connector announces it, so defaulting on costs nothing and keeps the feature
// discoverable for the DMs who do use it.
const KEY = "dmScreen.compassSync";

/** The stored choice, or the default (on). Never throws: a blocked or cleared
 *  store must still leave the console usable. Only an explicit "off" disables. */
export function isCompassSyncOn(): boolean {
  try { return localStorage.getItem(KEY) !== "off"; } catch { return true; }
}

const listeners = new Set<() => void>();

/** Turn the Compass lanes on or off and notify everything that reads this. */
export function setCompassSync(on: boolean): void {
  try { localStorage.setItem(KEY, on ? "on" : "off"); } catch { /* the preference is not worth failing over */ }
  listeners.forEach((fn) => fn());
}

/** useSyncExternalStore subscription, so App and the Sync-health checkbox stay in step. */
export function subscribeCompassSync(cb: () => void): () => void {
  listeners.add(cb);
  return () => { listeners.delete(cb); };
}
